import { createStore, applyMiddleware, Middleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "@redux-devtools/extension";

import { createRootReducer } from "../reducers";

const configureStore = () => {
    const middlewares: Middleware[] = [thunk];

    return createStore(createRootReducer(), composeWithDevTools(applyMiddleware(...middlewares)));
};

const store = configureStore();
export default store;
